import { computed, observable } from 'mobx';

import { delay, noop } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import lockAsync from '@src/utils/lock-async';
import { message } from 'antd';
import * as commonRegex from '@src/utils/common-regex';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import { useUnmount } from 'ahooks';

class SmsCodeInputStore {
  /**
   * 倒计时时长 默认:60s
   * @type {number}
   */
  countDownTime = 60;
  /**
   * 是否为第一次发送验证码
   * @type {boolean}
   */
  @observable smsFirstTimes = false;
  /**
   * 是否正在加载中
   * @type {boolean}
   */
  @observable isLoading = false;
  /**
   * 发送验证码异步请求
   * @type {function()}
   */
  sendCodeRequest = noop;
  /**
   * 接受验证的手机号码
   * @type {string}
   */
  @observable phone = '';

  /**
   * 倒计时显示
   * @type {null}
   */
  @observable countDownNumber = null;

  @computed
  get buttonText() {
    if (this.countDownNumber !== null) {
      return `${this.countDownNumber}秒后重试`;
    }
    if (this.smsFirstTimes) {
      return '重新发送';
    } else {
      return '获取验证码';
    }
  }

  @captchaHandlerDecorate('zt')
  sendCodeHandler({ ...authParams }) {
    return this.sendCodeRequest({ phone: this.phone, ...authParams });
  }

  /**
   * 发送验证码主要逻辑
   */
  @autobind
  @lockAsync()
  async onSmsButtonClick() {
    try {
      this.validate(this.phone);
      this.isLoading = true;
      const requestStatus = await this.sendCodeHandler();
      if (requestStatus && requestStatus.$state === 0 /**不选验证码直接关闭极验弹窗-进入此if*/) {
        return;
      }
      if (requestStatus) {
        this.countDown(this.countDownTime);
      }
    } catch (e) {
      message.error(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * 校验手机号码
   * @param phone
   * @returns {boolean}
   */
  @autobind
  validate(phone) {
    if (!phone) {
      throw new Error('手机号码不得为空');
    } else if (!commonRegex.phoneNumber.test(phone)) {
      throw new Error('请输入正确的手机号码');
    } else {
      // 通过校验, 不做其他处理
    }
  }

  /**
   * 倒计时
   * @param countDown
   * @returns {Promise<void>}
   */
  async countDown(countDown) {
    this.smsFirstTimes = true;
    const nextCountDown = countDown - 1;
    if (nextCountDown < 1) {
      this.countDownNumber = null;
      return;
    }
    this.countDownNumber = nextCountDown;
    await delay(1000);
    await this.countDown(nextCountDown);
  }

  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  use() {
    useUnmount(() => {
      this.smsFirstTimes = false;
      this.isLoading = false;
    });
  }
}

export default SmsCodeInputStore;
